<template>
    <div class="replyMain">
        <el-form ref="form" :model="form" label-width="100px" class="replyform">
            <el-form-item label="答辩方式:">
                <span v-if="scoreflag">{{ finalScore}}</span>
                <span v-if="waitflag">待审批</span>
            </el-form-item>
            <el-form-item label="答辩说明:">
                <p v-if="scoreflag" class="pline">{{finalOpinion}}
                </p>
                <span v-if="waitflag">待审批</span>
            </el-form-item>

        </el-form>
    </div>
</template>
<script>
export default {
    name: "write",
    data() {
        return {

        }
    }
}
</script>
<style  lang="less" scoped>
.replyMain {
    padding: 15px;

    .introduce {
        color: red;
        margin-bottom: 50px;
    }
    .replyform {
        width: 868px;
        margin: 0 auto;
    }
    
}
</style>


// WEBPACK FOOTER //
// src/pages/transactionPaper/writeGroup/reply.vue